import { render, staticRenderFns } from "./SectionAdsPerformance.vue?vue&type=template&id=ed8642f0&scoped=true&"
import script from "./SectionAdsPerformance.vue?vue&type=script&lang=js&"
export * from "./SectionAdsPerformance.vue?vue&type=script&lang=js&"
import style0 from "./SectionAdsPerformance.vue?vue&type=style&index=0&id=ed8642f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8642f0",
  null
  
)

export default component.exports